/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import { ThemeProvider, CSSReset } from "@chakra-ui/core";

import PropTypes from "prop-types"
import Header from "./header"
import styled from "@emotion/styled"
import Footer from "./footer"
import theme from "../theme"
import "./layout.scss"

import {
  Box, 
  Button, 
  Text, 
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  useDisclosure, 
} from "@chakra-ui/core"

const Styles = styled.main`
  
`


// const isBrowser = typeof window !== 'undefined';
// const firebase = isBrowser ? require('firebase/app') : 'div';
// const firebase = isBrowser ? require('firebase/firestore') : 'div';


// if (typeof window !== "undefined" && !firebase.apps.length) {
//   var firebaseConfig = {
//     apiKey: "",
//     authDomain: "",
//     databaseURL: "",
//     projectId: "",
//     storageBucket: "",
//     messagingSenderId: "",
//     appId: ""
//   }

//   firebase.initializeApp(firebaseConfig);
// }



class Layout extends React.Component {
  componentDidMount () {
    if ( !window.localStorage.ageVerified ) {
      document.querySelectorAll(".age-verified")[0].click()
    }

    if (typeof window !== undefined) {
      let dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'UA-165841978-1');
    }
  }
  render () {
    
  return (
    <ThemeProvider>
      <CSSReset />

      <Header search={this.props.search} />
      
      <Styles>
        <Box paddingTop="70px">
        { this.props.children }
        </Box>
        </Styles>

        <AgeVerify />
      
      <Footer />
      </ThemeProvider>
  )
}

}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout


function AgeVerify() {

  const { isOpen, onOpen, onClose } = useDisclosure();

  function setAgeVerified () {
    window.localStorage["ageVerified"] = true
    onClose()
  }
  
  return (
    <>
      <Button opacity="0" float="right" className="age-verified" onClick={onOpen}>Open Modal</Button>

      <Modal isOpen={isOpen} onClose={onClose} blockScrollOnMount={ true } closeOnOverlayClick={ false }>
        <ModalOverlay bg="#333333ee" />
        <ModalContent rounded="md">
          <ModalHeader>Age Verifcation</ModalHeader>
          <ModalBody>
            <Text>
              I am 21+ years old. 
            </Text>
          </ModalBody>

          <ModalFooter>
            <a href="https://instagram.com/prolificcoastseed" rel="noopener noreferrer">
            <Button variantColor="blue" mr={3}>
              Redirect
            </Button>
            </a>
            <Button variantColor="green" onClick={ setAgeVerified }>
              Confirm
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}